import {getCategoriesApi} from "../../api/entities/categories";
import {createFetchAllSlice} from "../genericCrudSlice";

export const fetchCategoriesSlice = createFetchAllSlice('categories', getCategoriesApi);
export const {fetchAllEntities: fetchCategories} = fetchCategoriesSlice;
export default fetchCategoriesSlice.reducer;
